// extracted by mini-css-extract-plugin
export default {"card":"Card_card__g0l1p"};